import { Controller } from "@hotwired/stimulus"
import Quill from 'quill';
import katex from 'katex';
import VideoBlot from '../extensions/quill/video_blot';
import 'quill/dist/quill.snow.css';

Quill.register(VideoBlot, true);
window.katex = katex;

export default class extends Controller {
  static targets = ["container", "hiddenField", "maxLengthLabel", "currentLengthLabel"]
  static values = {
    readOnly: { type: Boolean, default: false },
    maxLength: Number,
  }

  connect() {
    const toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      ['link', 'image', 'video', 'formula'],
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['clean']                                         // remove formatting button
    ];

    const quill = new Quill(this.containerTarget, {
      readOnly: this.readOnlyValue,
      modules: {
        toolbar: this.readOnlyValue ? false : toolbarOptions,
      },
      theme: 'snow',
      bounds: this.containerTarget,
    });

    if (this.hasHiddenFieldTarget) {
      quill.on('text-change', (_delta, oldDelta) => {
        if (this.maxLengthValue && this.maxLengthValue < this.calcLength(quill)) {
          quill.setContents(oldDelta, 'silent');
          quill.setSelection(oldDelta.length());
        } else {
          this.hiddenFieldTarget.value = this.containerTarget.querySelector('.ql-editor').innerHTML;

          if (this.hasCurrentLengthLabelTarget) {
            this.renderCurrentLength(quill);
          }
        }
      });
    }

    if (this.hasMaxLengthLabelTarget) {
      this.maxLengthLabelTarget.textContent = this.maxLengthValue;
    }

    if (this.hasCurrentLengthLabelTarget) {
      this.renderCurrentLength(quill);
    }
  }

  renderCurrentLength(quill) {
    this.currentLengthLabelTarget.textContent = this.calcLength(quill);
  }

  calcLength(quill) {
    return quill.getText().replace(/\r\n|\n/g, '').length;
  }
}
